export default __webpack_public_path__ + "static/media/logo-app.08726185.png";